import { render, staticRenderFns } from "./ledgerRole.vue?vue&type=template&id=73da381c&scoped=true&"
import script from "./ledgerRole.vue?vue&type=script&lang=js&"
export * from "./ledgerRole.vue?vue&type=script&lang=js&"
import style0 from "./ledgerRole.vue?vue&type=style&index=0&id=73da381c&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73da381c",
  null
  
)

export default component.exports